<div
  class="cads-tap-view"
  [class.cads-tap-view--tappable]="effectiveConfig().tappable"
  [attr.role]="effectiveConfig().tappable ? 'button' : null"
  [attr.tabindex]="effectiveConfig().tappable ? 0 : null"
  (click)="_onActivate()"
  (keydown)="_onKeydown($event)"
  (keyup)="_onKeyup($event)"
>
  <div class="cads-tap-view__row">
    <div class="cads-tap-view__content">
      <ng-content />
    </div>
    @if (showTrailingChevron()) {
      <span class="cads-tap-view__trailing" aria-hidden="true">
        <cads-icon-view-bit [config]="trailingChevronBitConfig()" />
      </span>
    }
  </div>
</div>
